import { RUTA_IMATGES, rutaPagina } from '../Compartido/contenidoCamprodon.js';

// Bloc del restaurant: foto gran a la dreta i targeta bordeus damunt.
const Restaurante = ({ textos, lang }) => (
    <section className="o-container position-relative">
        <div className="c-featured-slider position-relative">
            <picture>
                <source srcSet={RUTA_IMATGES + "restaurante.webp"} type="image/webp" />
                <img src={RUTA_IMATGES + "restaurante.jpg"} alt={textos.restaurante.alt} className="image-cover c-featured-slider__img" width="100%" height="100%" loading="lazy" decoding="async" />
            </picture>
            <div className="c-basic-card">
                <span className="c-basic-card__small-title text-uppercase">{textos.restaurante.antetitulo}</span>
                <p>{textos.restaurante.texto}</p>
                <a href={rutaPagina("restaurante", lang)} className="c-link">{textos.restaurante.enlace}</a>
            </div>
        </div>
    </section>
);

export default Restaurante;
